export const OrderPlaylist = {
  mounted() {
    this.items = this.el.querySelectorAll('[draggable="true"]');
    this.setupEvents();
  },

  setupEvents() {
    this.items.forEach((item) => {
      item.addEventListener("dragstart", this.setSource.bind(this));
      item.addEventListener("dragend", this.resetSource.bind(this));
      item.addEventListener("dragover", this.dragOver.bind(this));
      item.addEventListener("dragleave", this.dragLeave.bind(this));
      item.addEventListener("drop", this.drop.bind(this));
    });
  },

  setSource(e) {
    const draggableItem = e.target.closest('[draggable="true"]');
    this.activeSource = draggableItem.dataset.item;
    this.activeSourcePosition = parseInt(draggableItem.dataset.currentPosition);
  },

  resetSource() {
    this.activeSource = null;
    this.activeSourcePosition = null;
    this.removeDropIndicator();
  },

  dragOver(e) {
    e.preventDefault();

    const draggableItem = e.currentTarget.closest('[draggable="true"]');
    // Only process if we're directly over a draggable item
    if (!draggableItem?.dataset.position) return;

    const rect = draggableItem.getBoundingClientRect();
    const mouseY = e.clientY;
    const threshold = rect.top + rect.height / 2;

    this.removeDropIndicator();

    // Add the appropriate indicator based on mouse position
    if (mouseY < threshold) {
      draggableItem.classList.add("drop-above");
    } else {
      draggableItem.classList.add("drop-below");
    }
  },

  dragLeave(e) {
    // Only remove indicators if we're leaving the main draggable element
    if (e.currentTarget.dataset.position) {
      this.removeDropIndicator(e.currentTarget);
    }
  },

  drop(e) {
    const dropTarget = e.currentTarget;
    if (!dropTarget.dataset.position) return;

    this.removeDropIndicator(dropTarget);

    const targetPosition = parseInt(dropTarget.dataset.position);
    const sourcePosition = this.activeSourcePosition;
    const rect = dropTarget.getBoundingClientRect();

    // Determine if we should place below based on mouse position
    const placeBelow = e.clientY >= rect.top + rect.height / 2;

    // Calculate final position:
    // Start with target position + 1 (for 1-based indexing)
    // Add 1 if placing below
    // Subtract 1 if moving item down (source < target)
    const finalPosition =
      targetPosition +
      1 +
      (placeBelow ? 1 : 0) -
      (sourcePosition < targetPosition ? 1 : 0);

    this.pushEvent("change_position", {
      position: finalPosition,
      item: this.activeSource,
    });
  },

  removeDropIndicator(element = null) {
    if (element) {
      element.classList.remove("drop-above", "drop-below");
    } else {
      document.querySelectorAll(".drop-above, .drop-below").forEach((el) => {
        el.classList.remove("drop-above", "drop-below");
      });
    }
  },
};
